module.exports = __webpack_public_path__ + "hotWords.002d5e64.png";